import { Component, OnInit } from '@angular/core';
import { FlowchartPaper_History_Interface } from 'src/app/Interface/FlowchartPaper_History_Interface';
import { Empty_ProductRequest_Interface, ProductRequest_Interface } from 'src/app/Interface/ProductRequest_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FlowcharPaperService } from 'src/app/Service/Flowchart/FlowcharPaper.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { ProductRequestService } from 'src/app/Service/ProductRequest/ProductRequest.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ProductRequestList',
  templateUrl: './ProductRequestList.component.html',
  styleUrls: ['./ProductRequestList.component.scss']
})
export class ProductRequestListComponent implements OnInit {

  Token: String = ""

  BaseUrl1: string = ""
  BaseUrlCo: string = "&id2="
  page: number = 0;
  Procssing: boolean = false



  StartSearchDate: string = ''
  EndSearchDate: string = ''
  SubmitPeriodDate: string = '0'
  Filter_Status: string = '0'
  Filter_Product: string = ""
  Filter_title: string = ""



  FormTypeShow: string = 'List'

  modalRef_Delete: any;

  constructor(
    private FlowcharPaper_Service: FlowcharPaperService,
    private ProductRequest_Service: ProductRequestService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
  ) { }


  DataList_ProductRequest: Array<ProductRequest_Interface> = []
  DataList_History: Array<FlowchartPaper_History_Interface> = []
  Selected_ProductRequest_Record: ProductRequest_Interface = Empty_ProductRequest_Interface();

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.BaseUrl1 = environment.BaseUrl + "flowchart/WorkflowDetail?token=" + this.Token + "&id="
    this.Nav_Service.CheckValidPage(this.Token, 2208).subscribe(
      data => {

      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_ProductRequest(StartSearchDate, EndSearchDate) {
    this.Procssing = true
    this.ProductRequest_Service.GetProductRequest(this.Token,
      Number(this.SubmitPeriodDate),
      Number(this.Filter_Status),
      this.Filter_Product,
      StartSearchDate,
      EndSearchDate,
    ).subscribe(
      data => {

        this.DataList_ProductRequest = data
        this.Cal_Total_Price_Detail()
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Cal_Total_Price_Detail() {
    for (let itemT of this.DataList_ProductRequest) {
      itemT.totalPrice = 0
      for (let item of itemT.detail) {
        itemT.totalPrice = itemT.totalPrice + (item.price * item.amount)
      }
    }
  }


  Change_Filter_title() {
    this.page = 0
  }



  ReadData_History(item: ProductRequest_Interface) {
    this.Procssing = true
    this.FlowcharPaper_Service.History_WorkFlow(this.Token, item.flowchart.makerId).subscribe(
      data => {
        this.Selected_ProductRequest_Record = item
        this.DataList_History = data
        this.FormTypeShow = 'History'
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  ReadData_Form(item: ProductRequest_Interface) {
    this.Selected_ProductRequest_Record = item

    this.FormTypeShow = 'Form'
  }

  ReadData_View(item: ProductRequest_Interface) {
    this.Selected_ProductRequest_Record = item

    this.FormTypeShow = 'View'
  }

  Close_Show_History() {
    this.Selected_ProductRequest_Record = Empty_ProductRequest_Interface()
    this.FormTypeShow = 'List'
  }

  Change_visible(item: ProductRequest_Interface) {
    item.visible = !item.visible
  }

}
